import { useEffect, useState } from "react";
import useQuery from "../Hooks/useQueryHook/useQueryHook";
import axiosInstance from "../utilities/Axios";
import CreateIcon from "@mui/icons-material/Create";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  ListItemAvatar,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  Switch,
  Typography,
  ButtonGroup,
} from "@mui/material";
import { LinearProgress, Paper } from "@material-ui/core";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CountryProcessDisplayLabelEnum,
  ProcessCardEnum,
  ProcessCardEnumDisplayLabel,
  ProcessCardPassportEnumDisplayLabel,
  ProcessEnum,
  ProcessEnumDisplayLabel,
} from "../Types/Enum";
import ProcessCardDialogBox from "../Components/Process/ProcessCardDialogBox";
import { useSnackbar } from "notistack";

import Scaffold from "../Components/Layout/Scaffold";
import { LoadingStateContext } from "../Hooks/LoadingContext/LoadingContext";
import { ArrowForward, AttachmentOutlined, CancelOutlined, DeleteForeverOutlined, OpenInNew, OpenInNewOutlined, SyncOutlined, CheckOutlined, CloseOutlined } from "@mui/icons-material";
import { useFilePicker } from "use-file-picker";
import AlertDialogUpdate from "../Components/AlertDialog/AlertDialogUpdate";

const options = ["Sync Process"];

const ITEM_HEIGHT = 48;

const ProcessView = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [value, setValue] = useState({});
  const [processView, setProcessView] = useState<any>(null);
  const [processCards, setProcessCards] = useState<any[]>([]);
  const [processCard, setProcessCard] = useState<any>(null);
  const [resume, setResume] = useState<any>(null);
  const [activeCard, setActiveCard] = useState<any>(null);
  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [checked, setChecked] = React.useState(false);
  const [totalProcessingCards, setTotalProcessingCards] = React.useState(0);
  const [totalCompletedCards, setTotalCompletedCards] = React.useState(0);
  const [processId, setProcessId] = useState<any>(null);
  const [processArgs, setProcessArgs] = React.useState<{ [key: string]: any }>({});
  const { changeLoading, isLoading } = React.useContext(LoadingStateContext);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [localLoading, setLocalLoading] = useState({
    processCards: false,
    details: false,
    resume: false,
  });

  const [openFileSelector, { filesContent, plainFiles, clear, loading }] =
    useFilePicker({
      multiple: true,
      accept: [
        ".jpg",
        ".png",
        ".jpeg",
        ".pdf",
        ".docx",
        ".txt",
        ".mp4",
        ".avi",
      ],
      readAs: "ArrayBuffer",
    });

  const addAttachment = async (data: any) => {
    setLocalLoading((prev) => ({ ...prev, processCards: true }))
    try {
      if (plainFiles.length != 1) {
        throw "Please Select a File";
      }
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-attachments`;

      var formData = new FormData();
      formData.append("resume_id", resume.id);
      formData.append("note", 'Process Card Attachment');
      formData.append("type", "p");
      formData.append("attachment_type", 'PDF');
      formData.append("attachment_file", plainFiles[0]);
      formData.append("attachment_tag", 'other');
      formData.append("ref_id", data);

      await axiosInstance.post(url, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });

      clear();
      enqueueSnackbar(`Attachment Added Successfully!`, {
        variant: "success",
      })
      getProcessCards()
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Attachment uploading Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setLocalLoading((prev) => ({ ...prev, processCards: false }))
    }
  };

  const deleteAttachment = async (attachmentId: number) => {
    setLocalLoading((prev) => ({ ...prev, processCards: true }))
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/resume-attachments/${attachmentId}`;

      const response = await axiosInstance.delete(url);
      enqueueSnackbar(`Attachment Deletion Successful!`, {
        variant: "success",
      });
      getProcessCards()
    } catch (err: any) {
      console.error(err);
      enqueueSnackbar(
        `Attachment Deletion Unsuccessful! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
    } finally {
      setLocalLoading((prev) => ({ ...prev, processCards: false }))
    }
  };

  const open = Boolean(anchorEl);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeProcessStatusColor = (status: string) => {
    switch (status) {
      case ProcessEnum.completed:
        return "#00c853";
      case ProcessEnum.processing:
        return "#EDD029";
      case ProcessEnum.rejected:
        return "red";
      default:
    }
  };
  const changeProcessCardStatusColor = (status: string) => {
    switch (status) {
      case ProcessCardEnum.completed:
        return "#369845";
      case ProcessCardEnum.processing:
        return "#FFC300";
      case ProcessCardEnum.rejected:
        return "red";
      case ProcessCardEnum.approved:
        return "#DF7F13";
      default:
    }
  };
  useEffect(() => {
    const processId = query.get("processId");

    if (processId != null) {
      setProcessId(processId);
      getProcessByID(processId, EDialogAction.view);
      getProcessCards(processId);
      // getProcessCardByID(processId, EDialogAction.view);
    }
  }, []);
  useEffect(() => {
    calculateCards();
  }, [processCards]);

  useEffect(() => {
    calculateCards();
  }, [processCard]);

  const getResumeById = async (resumeId: number) => {
    changeLoading(true)
    setLocalLoading((prev) => ({ ...prev, resume: true }))
    try {
      const response = await axiosInstance.get(`/v1/resume/${resumeId}`, {});

      const data = response.data;
      setResume(data.result);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false)
      setLocalLoading((prev) => ({ ...prev, resume: false }))
    }
  };

  const processMarkAs = (data: { [key: string]: any }) => {
    setProcessArgs(data);
    setAlertDialogVisibility(true);
  };



  const syncProcess = async () => {
    changeLoading(true)
    try {

      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process/${processView.id}`;
      await axiosInstance
        .put(url, {
          // resume_id: processView.id,
          // country_process_id: processView.country_process_id,
          status: processView.status,
          note: processView.note,
        })
        .then((response) => {
        });
      getProcessByID(processId, EDialogAction.view);
      getProcessCards(processId);

      handleClose();
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false)
    }
  };

  const getProcessCards = async (id?: string) => {
    changeLoading(true)
    setLocalLoading((prev) => ({ ...prev, processCards: true }))
    try {
      const response = await axiosInstance.get(
        `/v1/process-card?process_id=${id ?? processId}`,
        {}
      );

      const data = response.data;
      const processData = data.result;
      setProcessCards(processData);

    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false)
      setLocalLoading((prev) => ({ ...prev, processCards: false }))
    }
  }

  const getProcessByID = async (processId: string, action: EDialogAction) => {
    changeLoading(true)
    setLocalLoading((prev) => ({ ...prev, details: true }))
    try {
      const response = await axiosInstance.get(`/v1/process/${processId}`, {});
      const data = response.data;
      const processData = data.result.process;
      setProcessView(processData);

      getResumeById(processData.resume_id);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false)
      setLocalLoading((prev) => ({ ...prev, details: false }))
    }
  };

  const getProcessCardByID = async (
    processCardId: string,
    action: EDialogAction
  ) => {

    setLocalLoading((prev) => ({ ...prev, processCards: true }))
    try {
      const response = await axiosInstance.get(
        `/v1/process-card/${processCardId}`,
        {}
      );

      const data = response.data;
      const processData = data.result;

      getResumeById(processData.resume_id);
      setProcessCard((prevProcessCard: any) => ({
        ...prevProcessCard,
        ...processData,
      }));

      if (action == EDialogAction.edit) {
        setEditDialogVisibility(true);
        setProcessCard((prevProcessCard: any) => ({
          ...prevProcessCard,
          ...processData,
        }));
      }
      if (action === EDialogAction.view) {
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLocalLoading((prev) => ({ ...prev, processCards: false }))
    }
  };

  const updateClosedProcess = async (data: any) => {
    setLocalLoading((prev) => ({ ...prev, processCards: true }));

    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/process-card/${data.id}`;

      const response = await axiosInstance.put(url, {
        ...data,
        status: "com",
      });

      const updatedStatus = response.data.result.status;
      setProcessCard((prevProcessCard: any) => ({
        ...prevProcessCard,
        status: updatedStatus,
      }));

      enqueueSnackbar("Process Card Updatation Successful! Process Card Completed!", {
        variant: "success",
      });

      await getProcessCards(processId);
    } catch (err) {
      enqueueSnackbar(
        `Process Card Updatation Unsuccessful! ${err}`, { variant: "error", }
      );
    } finally {
      setLocalLoading((prev) => ({ ...prev, processCards: false }));
    }
  };

  async function editDialogClose(callback: any, processCardId: any) {
    setLocalLoading((prev) => ({ ...prev, processCards: true }));
    if (typeof callback == "function") {
      callback(processCardId);
    }
    setTimeout(() => {
      getProcessCards(processId);
    }, 1000);
    setEditDialogVisibility(false)
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getProcessByID(processId, EDialogAction.view);
  }
  const resumePageChangeHandler = (resumeId: any) => {
    navigate({
      pathname: `/admin/resume-view/${resumeId}`,
      search: ``,
    });
  };

  const calculateCards = () => {
    let processCount = 0;
    let completeCount = 0;
    processCards.forEach((card) => {
      if (card.status == "proc" && card.country_process_card_tpl.title !== 'passport') {
        processCount = processCount + 1;
      } else if (card.status == "com") {
        completeCount = completeCount + 1;
      }
    });

    setTotalProcessingCards(processCount);
    setTotalCompletedCards(completeCount);
  };
  const handleBackButtonClick = () => {
    if (processView && processView.resume_id) {
      navigate(`/admin/recruitments?resume_id=${processView.resume_id}`);
    } else {
      window.history.back();
    }
  };

  return (
    <Scaffold
      title="Process View"
      actions={[]}
      showBackButton
      onBackButtonClick={handleBackButtonClick}
      mainAction={<>{!localLoading.details && processView && processView.status != "com" && <Button
        variant="contained"
        disabled={isLoading}
        startIcon={<SyncOutlined />}
        onClick={() => {
          syncProcess();
        }}
      >Sync Process</Button>}</>}
      isLoading={isLoading}
    >
      <>
        <>
          <Card
            elevation={0}
            className="border-2  "
            sx={{
              height: "100%",
              display: "flex",
              fontSize: "14px",
              minWidth: 275,
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "85%", padding: "10px" }}
            >
              <CardContent sx={{ width: "100%", flex: "1", display: "flex", flexDirection: "column" }} >
                <Grid container>
                  <Grid item xs={9}>
                    {!localLoading.details && processView && <Typography sx={{ fontSize: 18 }} color="text.secondary">
                      {processView.country_process.country_name}
                    </Typography>}
                    {localLoading.details && <Skeleton variant="text" width={100} />}
                  </Grid>
                  <Grid
                    container
                    item
                    xs={3}
                    sx={{ justifyContent: "flex-end" }}
                  >
                    {!localLoading.details && processView && <Chip
                      color={processView.status === ProcessEnum.completed || processView.status === ProcessEnum.processing ? "success" : processView.status === ProcessEnum.rejected || processView.status === ProcessEnum.processRejected ? "error" : "warning"}
                      label={ProcessEnumDisplayLabel[processView.status]}
                    />}
                    {localLoading.details && <Skeleton variant="rounded" width={100} />}
                  </Grid>
                </Grid>
                <Typography sx={{ fontSize: 24 }}>
                  {!localLoading.details && processView && processView.country_process.title}
                  {localLoading.details && <Skeleton variant="text" width={150} />}
                </Typography>
                {!localLoading.details && processView && processView.status == "proc" && (
                  <div className="relative flex-1 flex ">
                    <Button
                      variant="contained"
                      disabled={isLoading}
                      startIcon={<CheckOutlined />}
                      color={'success'}
                      onClick={() => {
                        processMarkAs({ status: 'com' });
                      }}
                      sx={{ marginTop: 'auto' }} // Apply marginTop: 'auto'
                    >
                      Complete
                    </Button>
                    <div className="px-1"></div>
                    <Button
                      variant="contained"
                      disabled={isLoading}
                      startIcon={<CloseOutlined />}
                      color={'error'}
                      onClick={() => {
                        processMarkAs({ status: 'proc_rej' });
                      }}
                      sx={{ marginTop: 'auto' }} // Apply marginTop: 'auto'
                    >
                      Reject
                    </Button>
                  </div>
                )}
              </CardContent>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Divider orientation="vertical" />
            </Box>
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "100%" }}
            >
              <CardContent>
                {!localLoading.resume && processView && resume && <List dense>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Name :</span>
                      <span className="font-bold"> {resume.first_name} {resume.last_name}</span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Job Title :</span>
                      <span className="font-bold"> {resume.base_job_title}</span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Passport No :</span>
                      <span className="font-bold"> {resume.passport_no}</span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Contact No :</span>
                      <span className="font-bold"> {resume.mobile_no1 ?? ''}</span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Button
                      endIcon={<ArrowForward />}
                      onClick={() => {
                        resumePageChangeHandler(processView.resume_id);
                      }}
                      variant="outlined"
                    >
                      Go to Resume
                    </Button>
                  </ListItem>
                </List>}
                {localLoading.resume && <List dense>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Name :</span>
                      <span className="font-bold"><Skeleton variant="text" width={100} /></span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Job Title :</span>
                      <span className="font-bold"><Skeleton variant="text" width={100} /></span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Passport No :</span>
                      <span className="font-bold"><Skeleton variant="text" width={100} /></span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography fontSize={16}>
                      <span className="mr-2">Contact No :</span>
                      <span className="font-bold"><Skeleton variant="text" width={100} /></span>
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Button
                      endIcon={<ArrowForward />}
                      onClick={() => {
                        resumePageChangeHandler(processView.resume_id);
                      }}
                      variant="outlined"
                    >
                      Go to Resume
                    </Button>
                  </ListItem>
                </List>}

              </CardContent>
            </Box>
          </Card>
        </>
        <Paper className="mt-4 border-2" elevation={0}>
          <Card className="border-b-2 rounded-b-none" elevation={0}>
            <div className="flex justify-evenly rounded-t-md">
              {!localLoading.processCards && processCards.filter(data => data.country_process_card_tpl.title !== 'passport').map((data: any, key: number) => (
                <div className={`h-1.5 border-x-2 w-full border-gray-900 border ${key < totalCompletedCards ? 'bg-green-700' : 'bg-orange-600'}`}></div>
              ))}
              {localLoading.processCards && <div className="h-1.5 border-x-2 w-full border-gray-900 border bg-indigo-600"></div>}
            </div>
            <div className="flex justify-between p-4">
              <Typography sx={{ fontSize: 18, fontWeight: "bold" }} color="text.secondary">
                Process Cards
              </Typography>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" align="center">
                {!localLoading.processCards && (`${totalCompletedCards}/${processCards.filter(data => data.country_process_card_tpl.title !== 'passport').length} Cards Completed (${totalProcessingCards} Pending)`)}
                {localLoading.processCards && <CircularProgress size={20} />}
              </Typography>
            </div>

          </Card>
          <Card className="p-2 m-4 bg-zinc-100 " elevation={0}>
            <Grid container rowSpacing={2} columnSpacing={2}>
              {processCards && processCards
                .sort((a, b) =>
                  a.country_process_card_tpl.order >
                    b.country_process_card_tpl.order
                    ? a
                    : b
                )
                .map((data: any, key: number) => {
                  // if (false) 
                  return (
                    <Card
                      key={data.id}
                      className="hover:shadow-md m-2 border"
                      sx={{
                        minWidth: 350,
                        borderRadius: "8px",
                      }}>
                      <div className="md:flex justify-between  p-3 border-b">
                        <Typography
                          sx={{ fontSize: 16, fontWeight: 'bold' }}
                          color="text.secondary"
                        >
                          {CountryProcessDisplayLabelEnum[data.country_process_card_tpl.title]}
                        </Typography>
                        <Chip
                          avatar={localLoading.processCards ? <Avatar ><CircularProgress size={20} color="primary" /></Avatar> : <></>}
                          disabled={localLoading.processCards}
                          label={data.country_process_card_tpl.title == 'passport' 
                          ?  ProcessCardPassportEnumDisplayLabel[data.status] 
                          : ProcessCardEnumDisplayLabel[data.status]} 
                          color={data.status === 'com' || data.status === 'return' ? 'success' : data.status === 'rej' ? 'error' : 'warning'} 
                          title={ProcessCardPassportEnumDisplayLabel[data.status] === 'Not Changed' && data.country_process_card_tpl.title == 'passport' ? 'Passport has not been collected or returned yet.' : ''}
                          />
                      </div>
                      <List className="border-b">
                        <ListItem>
                          <ListItemText primary="Updated on" secondary={data.updated_at.split("T", 1)} />
                        </ListItem>
                        <ListItem>
                          <ListItemText primary="Note" secondary={data.note ?? "N/A"} />
                        </ListItem>
                        <ListItem secondaryAction={
                          <ButtonGroup>
                            <Button
                              variant="contained"
                              color="info"
                              size="small"
                              disabled={localLoading.processCards || data.resume_attachment.length == 0}
                              onClick={() => {
                                if (activeCard == data.id) {
                                  setActiveCard(null)
                                } else {
                                  setActiveCard(data.id)
                                }
                              }}
                            >
                              {activeCard == data.id ? 'Hide' : 'View'}
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              disabled={localLoading.processCards}
                              onClick={() => {
                                setActiveCard(data.id)
                                openFileSelector()
                              }}
                              startIcon={<AttachmentOutlined />}
                            >
                              Add
                            </Button>
                          </ButtonGroup>
                        }>
                          <ListItemText
                            primary="Attachments"
                          />
                        </ListItem>
                        {activeCard == data.id && data.resume_attachment && data.resume_attachment.length > 0 && data.resume_attachment.map((attachment: any, index: any) =>
                          <ListItem secondaryAction={
                            <>
                              <IconButton
                                onClick={() => {
                                  window.open(`${process.env.REACT_APP_PUBLIC_FILE_PATH}${attachment.attachment_url}`, '_blank');
                                }}
                                color="primary">
                                <OpenInNewOutlined fontSize="small" />
                              </IconButton>
                              <IconButton
                                color="error"
                                disabled={localLoading.processCards}
                                onClick={() => deleteAttachment(attachment.id)} >
                                <DeleteForeverOutlined />
                              </IconButton>
                            </>
                          }>
                            <ListItemAvatar>
                              <Avatar>
                                <AttachmentOutlined />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText secondary={attachment.attachment_type} />
                          </ListItem>)}
                        {activeCard == data.id && filesContent.map((file, index) => (
                          <Card key={index} className="p-3 m-3">
                            <p className="text-sm">{file.name}</p>

                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className="m-1"
                                disabled={loading || localLoading.processCards}
                                onClick={() => {
                                  addAttachment(data.id);
                                }}
                              >
                                {loading ? <><CircularProgress color="warning" size={15} className="mr-2" /> Uploading</> : 'Add'}
                              </Button>
                              <Button
                                color="warning"
                                disabled={loading || localLoading.processCards}
                                onClick={() => {
                                  clear();
                                }}
                              >
                                <CancelOutlined />
                              </Button>
                            </>
                          </Card>
                        ))}
                        {data.attachments && <ListItem
                          secondaryAction={
                            <IconButton color="error" >
                              <DeleteForeverOutlined />
                            </IconButton>
                          }
                        >
                          <ListItemAvatar><Avatar><AttachmentOutlined /></Avatar></ListItemAvatar>
                          <ListItemText secondary={ProcessCardEnumDisplayLabel[data.status]} />
                        </ListItem>}
                      </List>
                      <div className="p-3 flex justify-start">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={localLoading.processCards}
                          endIcon={<CreateIcon />}
                          onClick={async () => {
                            await getProcessCardByID(
                              data.id,
                              EDialogAction.edit
                            );
                            setEditDialogVisibility(true);
                          }}>
                          EDIT
                        </Button>

                      </div>
                    </Card>
                  )
                  return (
                    <Grid item xs={4} key={data.id}>
                      <Card
                        className="hover:shadow-md"
                        sx={{
                          height: "100%",
                          display: "flex",
                          fontSize: "14px",
                          minWidth: 275,
                          borderRadius: "8px",
                          border: `1px solid ${data.status === 'com' ? '#00FF00' : '#FF0000'}`,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <CardContent sx={{ width: "100%" }}>
                            <Grid container sx={{ width: "100%" }}>
                              <Grid
                                container
                                item
                                xs={12}
                                sx={{ justifyContent: "flex-end", mb: "5px" }}
                              >
                                <button
                                  onClick={() => {
                                    console.log(data.id);
                                    getProcessCardByID(
                                      data.id,
                                      EDialogAction.edit
                                    );
                                    setEditDialogVisibility(true);
                                    console.log(editDialogVisibility);
                                  }}
                                >
                                  <CreateIcon
                                    sx={{
                                      fontSize: "15px",
                                      color: "GrayText",
                                    }}
                                  ></CreateIcon>
                                </button>
                              </Grid>
                              <Grid item xs={9}>
                                <Typography
                                  sx={{ fontSize: 14 }}
                                  color="text.secondary"
                                >
                                  {data.country_process_card_tpl.title}
                                </Typography>
                              </Grid>
                              <Grid
                                container
                                item
                                xs={3}
                                sx={{ justifyContent: "flex-end" }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    background: `${changeProcessCardStatusColor(
                                      data.status
                                    )}`,
                                    px: "6px",
                                    color: "white",
                                  }}
                                  color="text.secondary"
                                >
                                  {ProcessCardEnumDisplayLabel[data.status]}
                                </Typography>
                              </Grid>
                              <Grid container item xs={10}>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                  }}
                                  color="text.secondary"
                                >
                                  {data.note}
                                </Typography>
                              </Grid>
                              <Grid container item xs={4} sx={{ mt: "5px" }}>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                  }}
                                  color="text.secondary"
                                >
                                  Updated on:
                                </Typography>
                              </Grid>
                              <Grid container item xs={8} sx={{ mt: "5px" }}>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                  }}
                                  color="text.secondary"
                                >
                                  {data.updated_at.split("T", 1)}
                                </Typography>
                              </Grid>

                              <Grid
                                container
                                item
                                xs={6}
                                sx={{ justifyContent: "flex-end" }}
                              >
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      data.status == "com" ? (
                                        <Switch disabled defaultChecked />
                                      ) : (
                                        <Switch
                                          onChange={() => {
                                            updateClosedProcess(data.id);
                                          }}
                                          inputProps={{
                                            "aria-label": "controlled",
                                          }}
                                        />
                                      )
                                    }
                                    label="Complete"
                                  />
                                </FormGroup>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Box>
                        <CardActions>

                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Card>
        </Paper>
        <div>
          <ProcessCardDialogBox
            open={editDialogVisibility}
            onClose={() => editDialogClose(null, processCard.id)}
            data={processCard}
            dialogAction={dialogAction}
          />
          <AlertDialogUpdate
            openAlert={alertDialogVisibility}
            onCloseAlert={alertDialogClose}
            data={processView}
            additionalArgs={processArgs}
            action="processView"
          />
        </div>

      </>
    </Scaffold>
  );
};
export default ProcessView;
